export const text = 'text';
export const dropdown = 'dropdown';
export const multi_choice = 'multi_choice';
export const single_choice = 'single_choice';
export const phone = 'phone';
export const file_download = 'file_download';
export const none = '';
